import { Component, OnInit } from '@angular/core';
import {
  StepType,
  RegistrationStepQuery,
  RegistrationStepService,
  ErrorStateService,
  MemberDetails,
  ProviderTranslation,
  RegistrationStepStore,
  ProviderTranslationStatus,
} from '@fgb/core';

@Component({
  selector: 'fgb-registration-provider-translation',
  templateUrl: './registration-provider-translation.component.html',
  styleUrls: ['./registration-provider-translation.component.scss'],
})
export class RegistrationProviderTranslationComponent implements OnInit {
  readonly stepType = StepType.ProviderTranslation;

  externalRef: string = '';
  accountsList: ProviderTranslation[] = [];
  loading = true;
  title = '';
  description = '';

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private registrationStepStore: RegistrationStepStore,
    public errorService: ErrorStateService
  ) {}

  ngOnInit() {
    this.registrationStepService.getStepDataAndHandle(this.stepType);

    const externalRef = this.registrationStepQuery.getQueryData('externalRef');
    if (externalRef) {
      // Skip this step if we already selected an account when entering into the registration process
      let accountList = this.registrationStepQuery.getStep(this.stepType)?.Data as ProviderTranslation[];
      if (!accountList) {
        accountList = [{ ExternalRefNumber: externalRef, SelectedAccount: true }] as ProviderTranslation[];
      } else {
        let accountListCloned = JSON.parse(JSON.stringify(accountList)) as ProviderTranslation[];
        let currentAccount = accountListCloned.find((x) => x.ExternalRefNumber === externalRef) as ProviderTranslation;
        currentAccount.SelectedAccount = true;
        if (currentAccount !== null) {
          this.registrationStepStore.update(this.stepType, (step) => ({ ...step, Data: accountListCloned }));
        }
      }
      this.registrationStepService.submitRegistrationStepData(this.stepType, accountList).toPromise();
      return;
    }

    this.registrationStepService
      .fetchRegistrationStepForCurrentWizard(StepType.ProviderTranslation, true, true)
      .toPromise()
      .then((step) => {
        if (step.ShouldSkip) return;

        if (step && step.Data) {
          // x.Data is a <ProviderTranslationModel[]>
          this.accountsList = step.Data;
          if (this.accountsList.length === 1) {
            this._autoNextStep(this.accountsList[0]);
          } else {
            this.title = 'Choose Account';
            this.description = 'Please choose which account you would like to be linked.';
            this.loading = false;
          }
        } else {
          this.errorService.addError('Failed to retrieve available accounts.');
          this.loading = false;
        }
      });
  }

  private _autoNextStep(account: ProviderTranslation) {
    if (account.Status === ProviderTranslationStatus.Active) {
      document.location.href = account.RedirectUrl;
    } else {
      this.submitStep(account.ExternalRefNumber);
    }
  }

  public submitStep(externalRef: string) {
    if (!externalRef) {
      this.title = 'Account Selection';
      this.description = 'Sorry, we could not retrieve your account.';
      this.errorService.addError('No account selected.');
      return;
    }

    let accountList = this.registrationStepQuery.getStep(this.stepType)?.Data as ProviderTranslation[];
    if (!accountList) {
      accountList = [{ ExternalRefNumber: externalRef, SelectedAccount: true }] as ProviderTranslation[];
    }

    let accountListCloned = JSON.parse(JSON.stringify(accountList)) as ProviderTranslation[];
    let currentAccount = accountListCloned.find((x) => x.ExternalRefNumber === externalRef) as ProviderTranslation;
    currentAccount.SelectedAccount = true;
    if (currentAccount !== null) {
      this.registrationStepStore.update(this.stepType, (step) => ({ ...step, Data: accountListCloned }));
    }

    this.registrationStepService
      .submitRegistrationStepData(this.stepType, accountListCloned)
      .toPromise()
      .then(() => (this.loading = false));
  }

  public selectAccount(account: MemberDetails) {
    if (account.ExternalRefNumber) {
      this.externalRef = account.ExternalRefNumber;
    }
  }
}
